import { Router } from "@angular/router";
import { UserAPI } from "../../model";
import { ModalService } from "../shared/modal/modal.service";
import { UserService } from "../../services/user/user.service";
import { OAuthService } from "../../services/oauth/oauth.service";
import { CombiPackageService } from "../../services/combipackage/combipackage.service";
import { LocalStorageService } from "../../local-storage/local-storage.service";
import { UserApiModalComponent } from "./userapi-modal.component";
import { doOAuth } from "./oauth/oauth.util";

export interface ReconnectUserAPIDependencies {
  userService: UserService;
  router: Router;
  oAuthService: OAuthService;
  combiPackageService: CombiPackageService;
  localStorageService: LocalStorageService;
  modalService: ModalService<any>;
}

export const isOAuthUserAPI = (userApi: UserAPI): boolean =>
  userApi?.api?.configType === "OAUTH" || userApi?.api?.configType === "OAUTH_SNELSTART";

/**
 * Reconnects an existing userapi (new credentials for the same connection), so the integrations using it keep their
 * settings. Shared by the dashboard and the Shopify dashboard (COMBI-4714), so customers don't remove and reinstall an
 * integration to get a broken connection working again.
 *
 * @returns true when the connection was reconnected in a modal; false when it was cancelled, or when we left the page
 * for the OAuth provider (the page is loaded again after returning from it)
 */
export const reconnectUserAPI = async (userApi: UserAPI, deps: ReconnectUserAPIDependencies): Promise<boolean> => {
  if (isOAuthUserAPI(userApi)) {
    await doOAuth(deps.userService.getUser(), userApi, deps.combiPackageService, deps.oAuthService, deps.localStorageService, deps.modalService, deps.router);
    return false;
  }
  const modalService: ModalService<UserApiModalComponent> = deps.modalService.create(UserApiModalComponent);
  modalService.component.userApi = userApi;
  return !!(await modalService.open());
};
